import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAllMetrics } from 'features/metrics/useAllMetrics';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { getMetricValue } from './claimsTrendMetricsCardHelper';
import { MetricCardErrorState, MetricCardLoadingState, MetricCardNoDataText } from './MetricCardStates';

const CurrentEnrollmentMetricsCard = ({ width, height }) => {
  const [toggle, setToggle] = useState('Subscribers');

  // Use unified all-metrics VDS hook (single call for all 8 tiles)
  const { data: metricsData, loading, error } = useAllMetrics();

  const handleToggle = (event, newValue) => {
    if (newValue) setToggle(newValue);
  };

  const measureName = toggle === 'Subscribers' ? 'Subscribers' : 'Members';
  const extractedValue = getMetricValue(metricsData, measureName);

    // Show loading skeleton while data is being fetched
    if (loading) {
      return <MetricCardLoadingState width={width} height={height} borderRadius="24px" />;
    }

    if (error) {
      return <MetricCardErrorState title="Current Enrollment" />;
    }
    if(error || !metricsData || extractedValue === null || extractedValue === undefined) {
      return null;
    }

    return (
      <Box
        sx={{
          display: 'flex',
          height: '176px',
          padding: '24px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '8px',
          alignSelf: 'stretch',
          borderRadius: '16px',
          border: '1px solid var(--Gray---Line-Stroke, #71767A)',
          background: 'var(--white-bi, #FFF)',
        }}
      >
        <Typography 
          sx={{ 
            color: 'var(--Gray-Darkest---Body-Text, #121A22)', 
            fontFamily: 'Noto Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '150%',
          }}
        >
          Current Enrollment
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            alignSelf: 'stretch'
          }}
        >
        <ToggleButtonGroup
          value={toggle}
          exclusive
          onChange={handleToggle}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              border: 'none',
              borderRadius: '8px',
              bgcolor: 'transparent',
              px: 0,
              py: 0,
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'Noto Sans',
              lineHeight: '150%',
              textTransform: 'none',
              color: '#2F54A5',
              '&:hover': { bgcolor: 'transparent' },
              '&:hover:not(.Mui-selected)': { color: '#068DF1' },
              '&.Mui-selected': {
                bgcolor: 'transparent',
                fontWeight: 600,
                textDecoration: 'underline',
                textDecorationSkipInk: 'none'
              }
            },
            '& .MuiToggleButton-root + .MuiToggleButton-root': {
              marginLeft: '12px'
            }
          }}
        >
          <ToggleButton value="Subscribers">Subscribers</ToggleButton>
          <ToggleButton value="Members">Members</ToggleButton>
        </ToggleButtonGroup>
        </Box>
        { extractedValue != null ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', alignSelf: 'stretch', marginTop: 'auto' }}>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 400,
            fontStyle: 'normal',
            fontFamily: 'Noto Sans',
            color: '#121A22',
            lineHeight: '150%',
          }}
        >
          { extractedValue !== null ? new Intl.NumberFormat('en-US').format(parseFloat(extractedValue)) : extractedValue }
        </Typography>
        </Box>
         ) : (
        <MetricCardNoDataText />
      )}
    </Box>
    );
};

export default CurrentEnrollmentMetricsCard;